import Vue from "vue";

export default Vue.observable({ editMessage: null });



// WEBPACK FOOTER //
// ./src/components/V2/popup-chat/store/index.js